import usersApi from '../_api'
import budgetsApi from '@/modules/budgets/_api'
import { cloneDeep, forEach } from 'lodash-es'
import i18n from '@/locales/'

import { segmentTrack } from '@/analytics/segment'

export default {
  // Not really used, keep just in case for debugging
  createUser: async ({ getters, commit }, user) => {
    if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      await usersApi.postUsers(user)
    } catch (error) {
    } finally {
      commit('setIsCallingUsers', false)
    }
  },

  fetchUsers: async ({ getters, commit, dispatch }, pagination = true) => {
    if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const page = getters.currentPage
      const filters = getters.filters
      const response = await usersApi.getUsers(page, pagination, filters)
      const lastPage = response.headers['pagination-last-page']
      commit('setUsersLastPage', lastPage)
      commit('setUsersTotalItems', response.headers['pagination-total-items'])
      commit('setUsers', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_action_fetch_users_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  fetchUserLogged: async ({ getters, commit, dispatch, rootGetters }, userId) => {
    if (!userId) return
    try {
      const response = await usersApi.getUser(userId)
      commit('setUserLogged', response.data)
      if (rootGetters['LoginStore/loggedUserId'] === userId) {
        commit('setUserLoggedData', response.data)
      }
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'user_action_fetch_user_error' },
        { root: true }
      )
    }
  },
  fetchUser: async ({ getters, commit, dispatch, rootGetters }, userId) => {
    if (!userId) return
    try {
      const response = await usersApi.getUser(userId)
      commit('setUser', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'user_action_fetch_user_error' },
        { root: true }
      )
    }
  },
  updateUser: async ({ getters, commit, dispatch }, updatedUser) => {
    // if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const { id } = updatedUser

      const response = await usersApi.putUser(id, updatedUser)
      commit('updateUser', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_actions_update_user_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_actions_update_user_error' },
        { root: true }
      )
      throw error
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  updateUserOnlinePayment: async ({ getters, commit, dispatch }, updatedUser) => {
    if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const { id } = updatedUser

      const response = await usersApi.putUser(id, updatedUser)
      commit('updateUserList', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t(`users_actions_update_user_online_payment_${updatedUser.onlinePayments}`),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_actions_update_user_error' },
        { root: true }
      )
      throw error
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  updateUserList: async ({ getters, commit, dispatch }, updatedUser) => {
    // if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const { id } = updatedUser

      const response = await usersApi.putUser(id, updatedUser)
      commit('updateUserList', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_actions_update_user_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_actions_update_user_error' },
        { root: true }
      )
      throw error
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  removeUser: async ({ getters, commit, dispatch }, { userId, user = {} }) => {
    if (getters.isCallingUsers) return
    try {
      await usersApi.deleteUser(userId)
      segmentTrack('User invitation cancelled', {
        invitee_email: user.email,
        invitee_first_name: user.firstName,
        invitee_last_name: user.lastName,
        invitee_role: user.roles.join(',')
      })

      await commit('setIsCallingUsers', true)
      commit('removeUser', userId)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_action_cancel_user_invitation_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'users_actions_cancel_user_invitation_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  reinviteUser: async ({ getters, commit, dispatch }, { userId }) => {
    if (getters.isCallingUsers) return
    try {
      await usersApi.reinviteUser(userId)

      commit('setIsCallingUsers', true)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_action_reinvite_user_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'users_action_reinvite_user_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  fetchUserNotifications: async ({ getters, commit, dispatch, rootGetters }, userId) => {
    try {
      const response = await usersApi.getUserSettingNotifications()
      commit('setUserNotifications', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_action_fetch_users_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  updateUserNotifications: async ({ commit, dispatch }, settings) => {
    try {
      const response = await usersApi.postUserSettingNotifications(settings)
      commit('setUserNotifications', response.data)
      dispatch('SnackBars/addSuccess', i18n.t('user_post_settings_notification_success'), { root: true })
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_action_fetch_users_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },

  changeUserPassword: async (
    { getters, commit, dispatch },
    { id, oldPassword, password }
  ) => {
    if (!id || !oldPassword || !password || getters.isCallingUsers) return
    try {
      await usersApi.putUserPassword(id, {
        oldPassword: oldPassword,
        password: password
      })
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_change_user_password_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'user_change_user_password_error' },
        { root: true }
      )
    }
  },
  setUserPasscode: async (
    { getters, commit, dispatch },
    { id, password, passcode }
  ) => {
    try {
      if (getters.isCallingUsers || !password || !passcode) return
      await usersApi.putCreateUserPasscode(id, {
        password: password,
        passcode: passcode
      })
      commit('setIsCallingUsers', false)
      dispatch('fetchUser', id)
      dispatch('SnackBars/addSuccess', i18n.t('user_set_passcode_success'), {
        root: true
      })
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'user_set_passcode_error' },
        { root: true }
      )
    }
  },
  updateUserPasscode: async (
    { getters, commit, dispatch },
    { id, oldPasscode, newPasscode }
  ) => {
    try {
      if (getters.isCallingUsers || !oldPasscode || !newPasscode) return
      await usersApi.putUpdateUserPasscode(id, {
        oldPasscode: oldPasscode,
        passcode: newPasscode
      })
      segmentTrack('Passcode changed')
      commit('setIsCallingUsers', false)
      dispatch('fetchUser', id)

      dispatch('SnackBars/addSuccess', i18n.t('user_update_passcode_success'), {
        root: true
      })
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'user_update_passcode_error' },
        { root: true }
      )
      throw error
    }
  },

  requestResetPasscode: async ({ getters, commit, dispatch }, userId) => {
    try {
      if (getters.isCallingUsers) return
      commit('setIsCallingUsers', true)
      await usersApi.putRequestResetPasscode(userId)
      dispatch('SnackBars/addSuccess', i18n.t('user_request_reset_passcode_success'), { root: true })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'user_request_reset_password_error' }, { root: true })
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  resetPasscode: async ({ getters, commit, dispatch }, { userId, tokenData }) => {
    try {
      if (getters.isCallingUsers) return
      commit('setIsCallingUsers', true)
      await usersApi.putResetPasscode(userId, tokenData)
    } catch (error) {
      throw error
    } finally {
      commit('setIsCallingUsers', false)
    }
  },

  inviteUsers: async ({ getters, commit, dispatch }, { officeId, users }) => {
    try {
      if (getters.isCallingUsers) return
      commit('setIsCallingUsers', true)
      await usersApi.putOfficesUsers(officeId, { users: users })
      users.forEach(el => {
        segmentTrack('User invited', {
          invitee_email: el.email,
          invitee_first_name: el.firstName,
          invitee_last_name: el.lastName,
          invitee_role: el.role
        })
      })

      commit('setIsCallingUsers', false)
      await dispatch('fetchUsers')
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_actions_send_invitations_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_actions_send_invitations_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  toggleGetDeletedUsersFlag: ({ commit }) => {
    commit('toggleGetDeletedUsersFlag')
  },
  setUsersFilters: async ({ commit, getters, dispatch }, { filters, pagination = true }) => {
    // by default sort id desc.
    filters['order[id]'] = 'DESC'
    commit('setUsersFilters', filters)
    await dispatch('fetchUsers', pagination)
  },
  getUsersSearch: async ({ commit, getters, dispatch }, filters) => {
    // by default sort id desc.
    filters['order[id]'] = 'DESC'

    if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const page = getters.currentPage
      if (!getters.getDeletedUsersFlag) {
        filters['exists[deletedAt]'] = false
      }
      const response = await usersApi.getUsersAll(page, false, filters)
      const lastPage = response.headers['pagination-last-page']
      commit('setUsersLastPage', lastPage)
      commit('setUsersTotalItems', response.headers['pagination-total-items'])
      commit('setUsersSearch', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_action_fetch_users_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  addUsersFilters: ({ dispatch, getters }, newFilters) => {
    var currentFilters = cloneDeep(getters.filters)
    forEach(currentFilters, (e, k) => {
      const parts = k.split('[')
      if (parts.length === 1) return
      var searchedKey = parts[0]
      forEach(newFilters, (f, l) => {
        if (l.includes(searchedKey)) {
          delete currentFilters[k]
        }
      })
    })
    let mergeFilters = { ...currentFilters, ...newFilters }
    mergeFilters = forEach(mergeFilters, (e, k) => {
      if (e == null) {
        delete mergeFilters[k]
      }
    })
    dispatch('setUsersFilters', { filters: mergeFilters })
  },
  sortUsersByField: (
    { dispatch, getters, commit },
    { fieldName, direction = 'TOGGLE' }
  ) => {
    const fields = Array.isArray(fieldName) ? fieldName : [fieldName]
    let newFilters = {}
    fields.forEach(el => {
      const order = `order[${el}]`
      if (direction === 'TOGGLE') {
        direction = getters.filters[order] === 'DESC' ? 'ASC' : 'DESC'
      }
      newFilters[order] = direction
    })
    dispatch('addUsersFilters', newFilters)
  },
  activateUser: async ({ getters, commit, dispatch }, userId) => {
    if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const response = await usersApi.putActivateUser(userId)
      commit('updateUser', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_actions_activate_user_succes'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_actions_activate_user_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  archiveUser: async ({ getters, commit, dispatch }, userId) => {
    if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const response = await usersApi.putArchiveUser(userId)
      commit('updateUser', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('users_actions_archive_user_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_actions_archive_user_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  setUserPictureProfile: async ({ getters, commit, dispatch }, picture) => {
    if (getters.isCallingUsers) return
    try {
      const profilePicture = new FormData()
      profilePicture.append('file', picture)
      const response = await usersApi.postUserProfilePicture(profilePicture)
      commit('updateUser', response.data)
      commit('setUserLoggedData', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('user_profile_picture_updated'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'user_profile_picture_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUsers', false)
    }
  },
  nextUsersPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingUsers) return
    commit('incrementUsersCurrentPage')
    dispatch('fetchUsers')
  },

  /* - Methods Related to Budgets and Users  */

  fetchUserBudgets: async (
    { getters, commit, dispatch },
    { pagination = true, filters }
  ) => {
    if (getters.isCallingUserBudgets) return
    try {
      commit('setIsCallingUserBudgets', true)
      const page = getters.userBudgetsCurrentPage

      let response = []
      if (pagination) {
        response = await usersApi.getUserBudgets(page, true, filters)
      } else {
        response = await usersApi.getUserBudgets(page, false, filters)
      }
      const lastPage = Number.parseInt(
        response.headers['pagination-last-page']
      )
      commit('setUserBudgets', response.data)
      commit('setUserBudgetsLastPage', lastPage)
      commit('setUserBudgetsTotalItems', response.data.length)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'users_action_fetch_users_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingUserBudgets', false)
    }
  },
  clearUserBudgets: ({ commit }) => {
    commit('resetUserBudgets')
  },
  nextUserBudgetsPage: ({ commit, dispatch }, filters) => {
    commit('incrementUserBudgetsCurrentPage')
    dispatch('fetchUserBudgets', {
      pagination: filters.pagination,
      filters: filters.filters
    })
  },
  updateUserBudget: async ({ getters, commit, dispatch }, updatedBudget) => {
    if (getters.isCallingUserBudgets) return
    commit('setIsCallingUserBudgets', true)
    try {
      const { id } = updatedBudget
      const response = await budgetsApi.putUserBudgetsUser(id, updatedBudget)
      segmentTrack('Budget user assignation changed', {
        budget_id: response.data.budget.id,
        assignee_user: `${response.data.user.firstName} ${response.data.user.lastName}`,
        assigned: updatedBudget.assigned,
        budget_new_assigned_total: response.data.budget.assigned

      })

      commit('updateUserBudget', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('budgets_action_update_user_assigned_budget_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'budgets_action_update_user_assigned_budget_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingUserBudgets', false)
    }
  },

  fetchUsersForBudgets: async (
    { commit, getters, dispatch },
    officeId,
    filters = {}
  ) => {
    if (getters.isCallingUsers) return
    try {
      commit('setIsCallingUsers', true)
      const response = await usersApi.getUsersForBudgets(officeId, filters)
      commit('setUsers', response.data)
    } catch (error) {
      console.error(error)
    } finally {
      commit('setIsCallingUsers', false)
    }
  },

  clearUserList: ({ commit }) => {
    commit('clearUserList')
  },
  clearUsersSearchList: ({ commit }) => {
    commit('clearUsersSearchList')
  },
  logout: ({ commit }) => {
    commit('clearStoreData')
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData', 'userLogged')
  }
  /* -------------------------------- */
}
